<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Transfered Transactions</h4>
      </div>

      <div class="card-body">
        <ngx-datatable
          class="bootstrap core-bootstrap bg-white"
          [rows]="finance"
          [rowHeight]="78"
          [headerHeight]="60"
          [footerHeight]="38"
          [columnMode]="'force'"
          [scrollbarH]="true"
        >
          <!-- ID -->
          <ngx-datatable-column name="ID" prop="id" [flexGrow]="1">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="cell-line-height">
                <p
                  class="font-medium-1 font-weight-bold line-height-1 mb-25 text-start"
                >
                  {{ row.id }}
                </p>
              </div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Image" prop="image" [flexGrow]="5">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <img
                  [src]="getFirstImage(row.proofImageName)"
                  alt="Image"
                  class="avatar"
                  width="50"
                  height="50"
                  style="max-height: 50px; object-fit: cover"
                  (error)="handleImageError($event)"
                />
              </div>
            </ng-template>
          </ngx-datatable-column>

          <!-- earnings -->
          <ngx-datatable-column
            name="Amount "
            prop="paymentReason"
            [flexGrow]="2"
          >
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="cell-line-height">
                <p
                  class="font-medium-1 font-weight-bold line-height-1 mb-25 text-start"
                >
                  {{ row.amountCents / 100 | number }}
                  <small class="text-muted">{{ row.currency }}</small>
                </p>
              </div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Note" prop="paymentReason" [flexGrow]="2">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="cell-line-height">
                <p
                  class="font-medium-1 font-weight-bold line-height-1 mb-25 text-start"
                >
                  {{ row.note }}
                </p>
              </div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="Transfere Refrance"
            prop="paymentReason"
            [flexGrow]="2"
          >
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="cell-line-height">
                <p
                  class="font-medium-1 font-weight-bold line-height-1 mb-25 text-start"
                >
                  {{ row.transferRef }}
                </p>
              </div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name=" Status"
            prop="paymentReason"
            [flexGrow]="2"
          >
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="cell-line-height">
                <p
                  class="font-medium-1 font-weight-bold line-height-1 mb-25 text-start badge badge-pill"
                  [ngClass]="
                    row.status == 'completed'
                      ? 'bg-light-success'
                      : 'bg-light-warning'
                  "
                >
                  {{ row.status | uppercase }}
                </p>
              </div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="{{ 'MENU.DASHBOARD.ACTIONS' | translate }}"
            [flexGrow]="10"
          >
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <div ngbDropdown container="body">
                  <a
                    ngbDropdownToggle
                    href="javascript:void(0);"
                    class="hide-arrow"
                    id="dropdownBrowserState"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i
                      data-feather="more-vertical"
                      class="text-primary cursor-pointer mr-50"
                    ></i>
                  </a>
                  <div
                    ngbDropdownMenu
                    class="dropdown-menu-right"
                    aria-labelledby="dropdownBrowserState"
                  ></div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
